import { UsersPageThemeModeConfig } from './types';

const light: UsersPageThemeModeConfig = {
  usersPage: {},
};

export default light;
